<template>
  <el-dialog title="套打预览" :visible.sync="dialogVisible" append-to-body width="800px" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
    <el-button v-print="print" @click="addPlayTimes" type="primary">打印</el-button>
    <div ref="printBox" id="printBox" class="print">
      <div class="item" v-for="(item, i) in detail.list" :key="i" :style="{top: item.css.top, left: item.css.left, transform: item.css.transform}">{{ item.text }}</div>
    </div>
  </el-dialog>
</template>

<script>
import { printQualified, addPlayTimes, printQualified1, addPlayTimes1 } from '@/api/product/classManage'
export default {
  name: 'Print',
  data () {
    return {
      id: null,
      dialogVisible: false,
      type: 0,
      dpi: 0,
      print: {
        id: 'printBox'
      },
      detail: {
        width: '',
        height: '',
        wmm: 195,
        hmm: 138,
        list: [
          { key: 'one', css: { left: 20, top: 66, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'two', css: { left: 68, top: 66, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'three', css: { left: 42, top: 78, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'four', css: { left: 35, top: 93, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'five', css: { left: 30, top: 106, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'six', css: { left: 140, top: 18, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'seven', css: { left: 160, top: 33, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'eight', css: { left: 155, top: 49, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'nine', css: { left: 155, top: 66, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'ten', css: { left: 122, top: 105, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'eleven', css: { left: 141, top: 105, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } },
          { key: 'twelve', css: { left: 157, top: 105, fontSize: 5, fontFamily: 'sc-regular', fontWeight: 700 } }
        ]
      }
    }
  },
  methods: {
    async init (num, id, type) {
      // this.dpi = this.getDpi()
      // const one = this.dpi / 25.4 // 1mm
      // let width = this.detail.wmm * one
      // let height = this.detail.hmm * one
      this.id = id
      this.type = type
      let res
      if (type === 1) {
        res = await printQualified1({ id, type: this.checkAdmin() ? 1 : 2 })
      } else {
        res = await printQualified({ id, type: this.checkAdmin() ? 1 : 2 })
      }
      // console.log(res)
      this.detail = res.data
      this.detail.list = JSON.parse(res.data.style)
      this.detail.list.forEach(item => {
        item.css.left = (item.css.left * 1) + 'mm'
        item.css.top = (item.css.top * 1) + 'mm'
        item.css.fontSize = (item.css.fontSize * 1) + 'mm'
        item.text = this.detail[item.key]
        item.css.fontFamily = 'sc-regular'
        if (item.key === 'one' && item.text && item.text.length >= 5) {
          item.css.left = '15mm'
          item.css.top = '65mm'
          item.css.transform = 'scale(0.75)'
          if (item.text.length >= 8) {
            item.css.left = '14mm'
            item.css.transform = 'scale(0.65)'
          }
          if (item.text.length >= 10) {
            item.css.left = '8mm'
            item.css.transform = 'scale(0.6)'
          }
        }
        if (item.key === 'six') {
          const r = /([(|（|-])/g
          if (r.test(item.text)) {
            item.text = item.text.replace(/([(|（|-])/g, '\n$1')
            item.css.top = '11mm'
          }
        }
      })
      this.dialogVisible = true
      this.$nextTick(() => {
        document.querySelector('#printBox').style.width = (this.detail.wmm * 1) + 'mm'
        document.querySelector('#printBox').style.height = (this.detail.hmm * 1) + 'mm'
      })
    },
    async addPlayTimes () {
      if (this.type === 1) {
        const res = await addPlayTimes1({ id: this.id, type: this.checkAdmin() ? 1 : 2 })
      } else {
        const res = await addPlayTimes({ id: this.id })
      }
      setTimeout(() => {
        this.handleClose()
      }, 200);
    },
    handleClose () {
      this.dialogVisible = false
      this.$parent.getList()
    },
    getDpi () {
      for (var i = 56; i < 2000; i++) {
        if (matchMedia("(max-resolution: " + i + "dpi)").matches === true) {
          return i;
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.print {
  width: 100px;
  height: 100px;
  position: relative;
  font-family: SimHei;
  font-size: 18px;
  -webkit-print-color-adjust: exact;
  -moz-print-color-adjust: exact;
  -ms-print-color-adjust: exact;
  print-color-adjust: exact;
  color: #000;
  background: #fff;
  font-weight: bold;
  .item {
    position: absolute;
  }
}
@media print {
  body {
    color: #000;
    // font-weight: bold;
    background: #fff;
    font-family: Microsoft YaHei;
  }
  @page {
    size: auto;
    margin: 0;
  }
  #printBox {
    // transform:  scale(0.5) translate(-50%, -50%) !important;
  }
}
</style>
